﻿[
  {
    "draftJersey": "002",
    "name": "Albert Grau",
    "age": 20,
    "foot": "right",
    "height": 178,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/002.jpg",
    "macros": {
      "talent": 60,
      "defence": 60,
      "attack": 75,
      "positioning": 60,
      "average": 64
    },
    "profileYtVideoId": "Vf6GOLK-qKo",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "004",
    "name": "Alejandro Megia",
    "age": 25,
    "foot": "left",
    "height": 183,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/004.jpg",
    "macros": {
      "talent": 73,
      "defence": 78,
      "attack": 78,
      "positioning": 80,
      "average": 77
    },
    "profileYtVideoId": "oD_C1wvor9E",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": "005",
    "name": "Adrián Espinar",
    "age": 22,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/005.jpg",
    "macros": {
      "talent": 95,
      "defence": 90,
      "attack": 100,
      "positioning": 90,
      "average": 94
    },
    "profileYtVideoId": "6xjo3nDkk0I",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "006",
    "name": "Albert Ruiz",
    "age": 28,
    "foot": "right",
    "height": 181,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/006.jpg",
    "macros": {
      "talent": 60,
      "defence": 90,
      "attack": 70,
      "positioning": 70,
      "average": 73
    },
    "profileYtVideoId": "rMkfbujC9_s",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "007",
    "name": "Alberto Sánchez",
    "age": 22,
    "foot": "right",
    "height": 179,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/007.jpg",
    "macros": {
      "talent": 60,
      "defence": 60,
      "attack": 60,
      "positioning": 70,
      "average": 63
    },
    "profileYtVideoId": "HUvNEvtwwns",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "009",
    "name": "Carlos Contreras",
    "age": 30,
    "foot": "right",
    "height": 179,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/009.jpg",
    "macros": {
      "talent": 70,
      "defence": 63,
      "attack": 83,
      "positioning": 80,
      "average": 74
    },
    "profileYtVideoId": "B9Wjst80umY",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": "010",
    "name": "Aaron Valero",
    "age": 19,
    "foot": "right",
    "height": 180,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/010.jpg",
    "macros": {
      "talent": 75,
      "defence": 80,
      "attack": 85,
      "positioning": 75,
      "average": 79
    },
    "profileYtVideoId": "w3oxD5zPM-U",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "011",
    "name": "Adrià López",
    "age": 20,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/011.jpg",
    "macros": {
      "talent": 70,
      "defence": 75,
      "attack": 75,
      "positioning": 70,
      "average": 73
    },
    "profileYtVideoId": "HVyuT8vN9dc",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "012",
    "name": "Albert Giner",
    "age": 24,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/012.jpg",
    "macros": {
      "talent": 65,
      "defence": 60,
      "attack": 83,
      "positioning": 80,
      "average": 72
    },
    "profileYtVideoId": "RJMYbqvMIBc",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": "016",
    "name": "Manu Lanzarote",
    "age": 39,
    "foot": "left",
    "height": 178,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/016.jpg",
    "macros": {
      "talent": 60,
      "defence": 75,
      "attack": 80,
      "positioning": 80,
      "average": 74
    },
    "profileYtVideoId": "0bXEYbNh8yA",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": "017",
    "name": "Asier Izura",
    "age": 28,
    "foot": "left",
    "height": 186,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/017.jpg",
    "macros": {
      "talent": 78,
      "defence": 78,
      "attack": 75,
      "positioning": 80,
      "average": 78
    },
    "profileYtVideoId": "4bXr66kPp60",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "018",
    "name": "Cristhian Acevedo",
    "age": 27,
    "foot": "right",
    "height": 182,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/018.jpg",
    "macros": {
      "talent": 80,
      "defence": 70,
      "attack": 80,
      "positioning": 70,
      "average": 75
    },
    "profileYtVideoId": "aiOdJvY84ps",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "019",
    "name": "Dani Martí",
    "age": 40,
    "foot": "right",
    "height": 181,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/019.jpg",
    "macros": {
      "talent": 65,
      "defence": 65,
      "attack": 90,
      "positioning": 70,
      "average": 73
    },
    "profileYtVideoId": "Z7PtYqIDS7k",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "020",
    "name": "David Sánchez",
    "age": 31,
    "foot": "right",
    "height": 178,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/020.jpg",
    "macros": {
      "talent": 83,
      "defence": 75,
      "attack": 88,
      "positioning": 90,
      "average": 84
    },
    "profileYtVideoId": "FTnwvud4q_o",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "021",
    "name": "Enrique Arnaiz",
    "age": 20,
    "foot": "right",
    "height": 175,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/021.jpg",
    "macros": {
      "talent": 60,
      "defence": 68,
      "attack": 73,
      "positioning": 60,
      "average": 65
    },
    "profileYtVideoId": "9iRLWRCZYk4",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "022",
    "name": "Francesc Clotet",
    "age": 28,
    "foot": "left",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/022.jpg",
    "macros": {
      "talent": 65,
      "defence": 65,
      "attack": 65,
      "positioning": 60,
      "average": 64
    },
    "profileYtVideoId": "YjSzJNjbLWs",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "023",
    "name": "Godbless Eribo",
    "age": 26,
    "foot": "right",
    "height": 178,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/023.jpg",
    "macros": {
      "talent": 50,
      "defence": 70,
      "attack": 80,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "BRbSx_rs_Tg",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "024",
    "name": "Hicham Benamar",
    "age": 21,
    "foot": "right",
    "height": 188,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/024.jpg",
    "macros": {
      "talent": 60,
      "defence": 75,
      "attack": 65,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "MV6JlkMcs3k",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "025",
    "name": "Dídac Fernández",
    "age": 18,
    "foot": "right",
    "height": 186,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/025.jpg",
    "macros": {
      "talent": 80,
      "defence": 90,
      "attack": 80,
      "positioning": 80,
      "average": 83
    },
    "profileYtVideoId": "-OVHQKgLd88",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "026",
    "name": "Edu Saavedra",
    "age": 26,
    "foot": "right",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/026.jpg",
    "macros": {
      "talent": 75,
      "defence": 70,
      "attack": 60,
      "positioning": 75,
      "average": 70
    },
    "profileYtVideoId": "u4A9m3_g6yM",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "027",
    "name": "Zeus Rodríguez",
    "age": 36,
    "foot": "right",
    "height": 180,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/027.jpg",
    "macros": {
      "talent": 75,
      "defence": 80,
      "attack": 80,
      "positioning": 90,
      "average": 81
    },
    "profileYtVideoId": "7uBmR-KmsjY",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "028",
    "name": "Hichem Boumedol",
    "age": 29,
    "foot": "right",
    "height": 178,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/028.jpg",
    "macros": {
      "talent": 75,
      "defence": 80,
      "attack": 85,
      "positioning": 70,
      "average": 78
    },
    "profileYtVideoId": "vZ4Ha7j0IGw",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "030",
    "name": "Hugo Morillo",
    "age": 21,
    "foot": "right",
    "height": 178,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/030.jpg",
    "macros": {
      "talent": 75,
      "defence": 70,
      "attack": 75,
      "positioning": 70,
      "average": 73
    },
    "profileYtVideoId": "-lHtxYhQQJ4",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "031",
    "name": "Xavier Liebanas",
    "age": 26,
    "foot": "right",
    "height": 176,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/031.jpg",
    "macros": {
      "talent": 75,
      "defence": 75,
      "attack": 83,
      "positioning": 70,
      "average": 76
    },
    "profileYtVideoId": "pCUaBS_WSBQ",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "032",
    "name": "Francesc Aviles",
    "age": 31,
    "foot": "right",
    "height": 186,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/032.jpg",
    "macros": {
      "talent": 85,
      "defence": 100,
      "attack": 80,
      "positioning": 100,
      "average": 91
    },
    "profileYtVideoId": "AIDkMLulzqs",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "033",
    "name": "Iruene Bolaños",
    "age": 20,
    "foot": "right",
    "height": 176,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/033.jpg",
    "macros": {
      "talent": 70,
      "defence": 70,
      "attack": 65,
      "positioning": 90,
      "average": 74
    },
    "profileYtVideoId": "K8KZNU2D-Eg",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "035",
    "name": "José A. Rodríguez",
    "age": 38,
    "foot": "right",
    "height": 180,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/035.jpg",
    "macros": {
      "talent": 65,
      "defence": 75,
      "attack": 65,
      "positioning": 70,
      "average": 69
    },
    "profileYtVideoId": "rRqKwHr3Cx8",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": "036",
    "name": "Nil Torras",
    "age": 25,
    "foot": "left",
    "height": 175,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/036.jpg",
    "macros": {
      "talent": 95,
      "defence": 90,
      "attack": 100,
      "positioning": 100,
      "average": 96
    },
    "profileYtVideoId": "OgW2E5-sRs0",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "037",
    "name": "José Manuel Foncuberta",
    "age": 23,
    "foot": "right",
    "height": 172,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/037.jpg",
    "macros": {
      "talent": 83,
      "defence": 78,
      "attack": 85,
      "positioning": 85,
      "average": 83
    },
    "profileYtVideoId": "GEOEWWzuS_Q",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "038",
    "name": "Lasha L. Macharashvili",
    "age": 21,
    "foot": "right",
    "height": 185,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/038.jpg",
    "macros": {
      "talent": 83,
      "defence": 80,
      "attack": 85,
      "positioning": 70,
      "average": 80
    },
    "profileYtVideoId": "Au7IIhGV0mc",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "039",
    "name": "Rafael Berlanga",
    "age": 29,
    "foot": "left",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/039.jpg",
    "macros": {
      "talent": 65,
      "defence": 55,
      "attack": 75,
      "positioning": 60,
      "average": 64
    },
    "profileYtVideoId": "jtDa6PcxsSU",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": "040",
    "name": "Redu Drissi",
    "age": 34,
    "foot": "right",
    "height": 175,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/040.jpg",
    "macros": {
      "talent": 55,
      "defence": 70,
      "attack": 75,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "RBdpWFjpb8w",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": "044",
    "name": "Joel Zamora",
    "age": 25,
    "foot": "right",
    "height": 177,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/044.jpg",
    "macros": {
      "talent": 75,
      "defence": 85,
      "attack": 73,
      "positioning": 75,
      "average": 77
    },
    "profileYtVideoId": "LsesHPqfEGg",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "045",
    "name": "Jonatan Izquierdo",
    "age": 31,
    "foot": "right",
    "height": 179,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/045.jpg",
    "macros": {
      "talent": 75,
      "defence": 70,
      "attack": 70,
      "positioning": 90,
      "average": 76
    },
    "profileYtVideoId": "6csjOt0561c",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": "046",
    "name": "Marc Alegre",
    "age": 34,
    "foot": "right",
    "height": 180,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/046.jpg",
    "macros": {
      "talent": 68,
      "defence": 53,
      "attack": 85,
      "positioning": 80,
      "average": 72
    },
    "profileYtVideoId": "UQIltbEFP_s",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": "051",
    "name": "Raül Vilaró",
    "age": 21,
    "foot": "left",
    "height": 196,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/051.jpg",
    "macros": {
      "talent": 55,
      "defence": 70,
      "attack": 65,
      "positioning": 80,
      "average": 68
    },
    "profileYtVideoId": "vxgki-kqTT4",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": "052",
    "name": "Sergio Fernández",
    "age": 21,
    "foot": "left",
    "height": 176,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/052.jpg",
    "macros": {
      "talent": 60,
      "defence": 65,
      "attack": 60,
      "positioning": 60,
      "average": 61
    },
    "profileYtVideoId": "gRSDaZYy-L4",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": "053",
    "name": "Vicenç Oromí",
    "age": 19,
    "foot": "right",
    "height": 184,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/053.jpg",
    "macros": {
      "talent": 75,
      "defence": 80,
      "attack": 100,
      "positioning": 90,
      "average": 86
    },
    "profileYtVideoId": "iOSUWZSn7tE",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": "057",
    "name": "Nil Ayats",
    "age": 25,
    "foot": "left",
    "height": 174,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/057.jpg",
    "macros": {
      "talent": 83,
      "defence": 75,
      "attack": 83,
      "positioning": 75,
      "average": 79
    },
    "profileYtVideoId": "lzv7Zq563D8",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": "058",
    "name": "Oscar Coll",
    "age": 23,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/058.jpg",
    "macros": {
      "talent": 80,
      "defence": 70,
      "attack": 78,
      "positioning": 85,
      "average": 78
    },
    "profileYtVideoId": "emHLVM3Ucng",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": "059",
    "name": "Oscar Contreras",
    "age": 25,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/059.jpg",
    "macros": {
      "talent": 90,
      "defence": 80,
      "attack": 100,
      "positioning": 90,
      "average": 90
    },
    "profileYtVideoId": "VVIhPhAj_SM",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": "060",
    "name": "Sergi Villegas",
    "age": 20,
    "foot": "left",
    "height": 181,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/060.jpg",
    "macros": {
      "talent": 65,
      "defence": 80,
      "attack": 70,
      "positioning": 60,
      "average": 69
    },
    "profileYtVideoId": "f4JDXwhNYXk",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": "061",
    "name": "Toni Soler",
    "age": 31,
    "foot": "left",
    "height": 177,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/061.jpg",
    "macros": {
      "talent": 65,
      "defence": 55,
      "attack": 55,
      "positioning": 60,
      "average": 59
    },
    "profileYtVideoId": "hzjXFzWV_xM",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": "062",
    "name": "Uriel Araujo",
    "age": 22,
    "foot": "left",
    "height": 182,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/062.jpg",
    "macros": {
      "talent": 63,
      "defence": 60,
      "attack": 75,
      "positioning": 70,
      "average": 67
    },
    "profileYtVideoId": "cgnnWgGLgWU",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": "065",
    "name": "Jordi Abelló",
    "age": 23,
    "foot": "right",
    "height": 182,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/065.jpg",
    "macros": {
      "talent": 60,
      "defence": 55,
      "attack": 60,
      "positioning": 70,
      "average": 61
    },
    "profileYtVideoId": "1-o1PWShSsk",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": "066",
    "name": "Eloy Pizarro",
    "age": 20,
    "foot": "right",
    "height": 186,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/066.jpg",
    "macros": {
      "talent": 90,
      "defence": 100,
      "attack": 100,
      "positioning": 100,
      "average": 98
    },
    "profileYtVideoId": "C-KnU-mJbI0",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": "068",
    "name": "Eduardo Mas",
    "age": 32,
    "foot": "left",
    "height": 186,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/068.jpg",
    "macros": {
      "talent": 70,
      "defence": 60,
      "attack": 85,
      "positioning": 60,
      "average": 69
    },
    "profileYtVideoId": "Qj-UrxDu0p0",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 100,
    "name": "Alejandro Ballesteros",
    "age": 22,
    "foot": "right",
    "height": 186,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/100.jpg",
    "macros": {
      "talent": 70,
      "defence": 78,
      "attack": 70,
      "positioning": 70,
      "average": 72
    },
    "profileYtVideoId": "-v4ViyoHamc",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 103,
    "name": "Alex Cubedo",
    "age": 24,
    "foot": "right",
    "height": 181,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/103.jpg",
    "macros": {
      "talent": 50,
      "defence": 75,
      "attack": 65,
      "positioning": 70,
      "average": 65
    },
    "profileYtVideoId": "1CDGnKE_BW0",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 104,
    "name": "Aleix Martí",
    "age": 18,
    "foot": "left",
    "height": 173,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/104.jpg",
    "macros": {
      "talent": 95,
      "defence": 75,
      "attack": 90,
      "positioning": 90,
      "average": 88
    },
    "profileYtVideoId": "0SG3rDUfXOU",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 105,
    "name": "Alex Poves",
    "age": 31,
    "foot": "right",
    "height": 185,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/105.jpg",
    "macros": {
      "talent": 70,
      "defence": 75,
      "attack": 65,
      "positioning": 80,
      "average": 73
    },
    "profileYtVideoId": "ZQLZtNKgNVU",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 107,
    "name": "José 'Casi' Ruiz",
    "age": 30,
    "foot": "right",
    "height": 184,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/107.jpg",
    "macros": {
      "talent": 55,
      "defence": 73,
      "attack": 75,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "v5PvuwaI0Ds",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 108,
    "name": "Daniel Ruiz",
    "age": 24,
    "foot": "left",
    "height": 187,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/108.jpg",
    "macros": {
      "talent": 60,
      "defence": 60,
      "attack": 80,
      "positioning": 60,
      "average": 65
    },
    "profileYtVideoId": "vv_0gkaAznI",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 109,
    "name": "Alejandro Danoz",
    "age": 20,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/109.jpg",
    "macros": {
      "talent": 60,
      "defence": 85,
      "attack": 70,
      "positioning": 75,
      "average": 73
    },
    "profileYtVideoId": "t6hgb4pXLoM",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 110,
    "name": "Alejandro Ortega",
    "age": 18,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/110.jpg",
    "macros": {
      "talent": 80,
      "defence": 95,
      "attack": 100,
      "positioning": 100,
      "average": 94
    },
    "profileYtVideoId": "O9514r_ciLM",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 111,
    "name": "Alfons Serra",
    "age": 32,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/111.jpg",
    "macros": {
      "talent": 75,
      "defence": 70,
      "attack": 85,
      "positioning": 80,
      "average": 78
    },
    "profileYtVideoId": "LlErgqmMKRg",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 112,
    "name": "Carlos Ferres",
    "age": 28,
    "foot": "left",
    "height": 173,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/112.jpg",
    "macros": {
      "talent": 70,
      "defence": 60,
      "attack": 83,
      "positioning": 80,
      "average": 73
    },
    "profileYtVideoId": "sikS4eLAIWI",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 113,
    "name": "Cristian Hidalgo",
    "age": 39,
    "foot": "right",
    "height": 171,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/113.jpg",
    "macros": {
      "talent": 75,
      "defence": 60,
      "attack": 95,
      "positioning": 100,
      "average": 83
    },
    "profileYtVideoId": "BJeNkOATGGk",
    "matchYtVideoId": "VSjoFanU7aM"
  },
  {
    "draftJersey": 114,
    "name": "Dani Liñares",
    "age": 25,
    "foot": "right",
    "height": 171,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/114.jpg",
    "macros": {
      "talent": 60,
      "defence": 60,
      "attack": 70,
      "positioning": 70,
      "average": 65
    },
    "profileYtVideoId": "1U4HOy711vU",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 115,
    "name": "Adrià Escribano",
    "age": 30,
    "foot": "right",
    "height": 178,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/115.jpg",
    "macros": {
      "talent": 75,
      "defence": 75,
      "attack": 80,
      "positioning": 70,
      "average": 75
    },
    "profileYtVideoId": "i31N6bS4Fu8",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": 116,
    "name": "Cristian Pacheco",
    "age": 24,
    "foot": "left",
    "height": 170,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/116.jpg",
    "macros": {
      "talent": 70,
      "defence": 55,
      "attack": 65,
      "positioning": 80,
      "average": 68
    },
    "profileYtVideoId": "iluod18V_uM",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 118,
    "name": "David Cárdenas",
    "age": 38,
    "foot": "right",
    "height": 183,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/118.jpg",
    "macros": {
      "talent": 65,
      "defence": 85,
      "attack": 70,
      "positioning": 80,
      "average": 75
    },
    "profileYtVideoId": "_btGPfyZm4o",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 120,
    "name": "Eric López",
    "age": 30,
    "foot": "right",
    "height": 178,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/120.jpg",
    "macros": {
      "talent": 68,
      "defence": 70,
      "attack": 70,
      "positioning": 75,
      "average": 71
    },
    "profileYtVideoId": "pnrtaXDC_O0",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 121,
    "name": "Eric Olmedo",
    "age": 21,
    "foot": "left",
    "height": 181,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/121.jpg",
    "macros": {
      "talent": 75,
      "defence": 85,
      "attack": 90,
      "positioning": 90,
      "average": 85
    },
    "profileYtVideoId": "-w8FNg-DiX8",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 122,
    "name": "John de la Cruz",
    "age": 19,
    "foot": "right",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/122.jpg",
    "macros": {
      "talent": 75,
      "defence": 75,
      "attack": 85,
      "positioning": 80,
      "average": 79
    },
    "profileYtVideoId": "sm79qW8KdEA",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 123,
    "name": "Jordi Martínez",
    "age": 28,
    "foot": "right",
    "height": 176,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/123.jpg",
    "macros": {
      "talent": 70,
      "defence": 70,
      "attack": 85,
      "positioning": 80,
      "average": 76
    },
    "profileYtVideoId": "b0kKRdC-ERQ",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 124,
    "name": "Jorge Macia",
    "age": 18,
    "foot": "right",
    "height": 176,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/124.jpg",
    "macros": {
      "talent": 65,
      "defence": 65,
      "attack": 65,
      "positioning": 70,
      "average": 66
    },
    "profileYtVideoId": "Frz0HNs-vZY",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 126,
    "name": "Gabriel Vidal",
    "age": 28,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/126.jpg",
    "macros": {
      "talent": 80,
      "defence": 83,
      "attack": 83,
      "positioning": 70,
      "average": 79
    },
    "profileYtVideoId": "F90Iyo3Fuv8",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 127,
    "name": "Guillermo Veintemilla",
    "age": 29,
    "foot": "right",
    "height": 174,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/127.jpg",
    "macros": {
      "talent": 60,
      "defence": 70,
      "attack": 70,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "44EvZ2n9tS8",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 128,
    "name": "Iker González",
    "age": 21,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/128.jpg",
    "macros": {
      "talent": 55,
      "defence": 65,
      "attack": 70,
      "positioning": 70,
      "average": 65
    },
    "profileYtVideoId": "_HJvGDljJg8",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 129,
    "name": "Iker Miravalles",
    "age": 20,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/129.jpg",
    "macros": {
      "talent": 60,
      "defence": 70,
      "attack": 70,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "1wVVbwB2CSw",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 130,
    "name": "Isaac Maldonado",
    "age": 33,
    "foot": "right",
    "height": 177,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/130.jpg",
    "macros": {
      "talent": 60,
      "defence": 60,
      "attack": 65,
      "positioning": 60,
      "average": 61
    },
    "profileYtVideoId": "FN96GrSfZEk",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 131,
    "name": "Jan Coca",
    "age": 19,
    "foot": "right",
    "height": 165,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/131.jpg",
    "macros": {
      "talent": 73,
      "defence": 60,
      "attack": 80,
      "positioning": 60,
      "average": 68
    },
    "profileYtVideoId": "qUG_WzHcfls",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 134,
    "name": "Nacho Pedraza",
    "age": 38,
    "foot": "left",
    "height": 182,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/134.jpg",
    "macros": {
      "talent": 95,
      "defence": 95,
      "attack": 100,
      "positioning": 100,
      "average": 98
    },
    "profileYtVideoId": "9V2CPPbiDM8",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 135,
    "name": "Nicolás Santos",
    "age": 23,
    "foot": "right",
    "height": 184,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/135.jpg",
    "macros": {
      "talent": 75,
      "defence": 95,
      "attack": 100,
      "positioning": 90,
      "average": 90
    },
    "profileYtVideoId": "75HcrTlP8qQ",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 136,
    "name": "Samuel Fernández",
    "age": 23,
    "foot": "right",
    "height": 170,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/136.jpg",
    "macros": {
      "talent": 85,
      "defence": 55,
      "attack": 75,
      "positioning": 70,
      "average": 71
    },
    "profileYtVideoId": "zrtRrPB5sFU",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 137,
    "name": "Samuel Rodriguez",
    "age": 29,
    "foot": "right",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/137.jpg",
    "macros": {
      "talent": 70,
      "defence": 65,
      "attack": 80,
      "positioning": 70,
      "average": 71
    },
    "profileYtVideoId": "ZfXVOEcfaOw",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 138,
    "name": "Sergi Gestí",
    "age": 29,
    "foot": "right",
    "height": 173,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/138.jpg",
    "macros": {
      "talent": 63,
      "defence": 65,
      "attack": 60,
      "positioning": 60,
      "average": 62
    },
    "profileYtVideoId": "Vicks-OyfQI",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 139,
    "name": "Juan Carlos Marrero",
    "age": 21,
    "foot": "right",
    "height": 184,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/139.jpg",
    "macros": {
      "talent": 70,
      "defence": 90,
      "attack": 70,
      "positioning": 90,
      "average": 80
    },
    "profileYtVideoId": "gFfIzvNGIZE",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 140,
    "name": "Juan Manuel Peña",
    "age": 19,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/140.jpg",
    "macros": {
      "talent": 65,
      "defence": 75,
      "attack": 80,
      "positioning": 80,
      "average": 75
    },
    "profileYtVideoId": "aWryR4wZJTk",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 141,
    "name": "Pol Font",
    "age": 32,
    "foot": "left",
    "height": 176,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/141.jpg",
    "macros": {
      "talent": 85,
      "defence": 75,
      "attack": 78,
      "positioning": 85,
      "average": 81
    },
    "profileYtVideoId": "SPt1a8BcPzk",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 145,
    "name": "Pol Román",
    "age": 24,
    "foot": "right",
    "height": 175,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/145.jpg",
    "macros": {
      "talent": 80,
      "defence": 80,
      "attack": 80,
      "positioning": 80,
      "average": 80
    },
    "profileYtVideoId": "ZW4-1BOsUZ8",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 147,
    "name": "Pau Llastarry",
    "age": 22,
    "foot": "left",
    "height": 175,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/147.jpg",
    "macros": {
      "talent": 60,
      "defence": 70,
      "attack": 75,
      "positioning": 70,
      "average": 69
    },
    "profileYtVideoId": "GJuwQR5M62k",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 148,
    "name": "Pol Marcó",
    "age": 28,
    "foot": "right",
    "height": 197,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/148.jpg",
    "macros": {
      "talent": 55,
      "defence": 60,
      "attack": 75,
      "positioning": 60,
      "average": 63
    },
    "profileYtVideoId": "vNHaxoUy_PY",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 150,
    "name": "Antonio Hernández",
    "age": 26,
    "foot": "right",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/150.jpg",
    "macros": {
      "talent": 95,
      "defence": 80,
      "attack": 88,
      "positioning": 90,
      "average": 88
    },
    "profileYtVideoId": "oD6Wli9LYko",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 151,
    "name": "Lele Montero",
    "age": 38,
    "foot": "right",
    "height": 185,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/151.jpg",
    "macros": {
      "talent": 68,
      "defence": 55,
      "attack": 85,
      "positioning": 80,
      "average": 72
    },
    "profileYtVideoId": "KbWLZiQCDEw",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 154,
    "name": "Pablo Fernández",
    "age": 27,
    "foot": "right",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/154.jpg",
    "macros": {
      "talent": 63,
      "defence": 65,
      "attack": 75,
      "positioning": 70,
      "average": 68
    },
    "profileYtVideoId": "svta73hZ17I",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 155,
    "name": "Samir Diri",
    "age": 32,
    "foot": "left",
    "height": 184,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/155.jpg",
    "macros": {
      "talent": 90,
      "defence": 100,
      "attack": 90,
      "positioning": 100,
      "average": 95
    },
    "profileYtVideoId": "EWxIKTdwfgA",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 156,
    "name": "Sergi Cabré",
    "age": 25,
    "foot": "right",
    "height": 170,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/156.jpg",
    "macros": {
      "talent": 100,
      "defence": 80,
      "attack": 90,
      "positioning": 100,
      "average": 93
    },
    "profileYtVideoId": "2_ELc3sNJr8",
    "matchYtVideoId": "DF46sNWDPjs"
  },
  {
    "draftJersey": 158,
    "name": "Adrián Frutos",
    "age": 32,
    "foot": "left",
    "height": 169,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/158.jpg",
    "macros": {
      "talent": 73,
      "defence": 65,
      "attack": 83,
      "positioning": 80,
      "average": 75
    },
    "profileYtVideoId": "fL2o0wnfeLY",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 159,
    "name": "Jerónimo Martín",
    "age": 27,
    "foot": "right",
    "height": 175,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/159.jpg",
    "macros": {
      "talent": 70,
      "defence": 75,
      "attack": 80,
      "positioning": 70,
      "average": 74
    },
    "profileYtVideoId": "QqfSYxlgkXY",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 160,
    "name": "Jorge Gutiérrez",
    "age": 30,
    "foot": "right",
    "height": 178,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/160.jpg",
    "macros": {
      "talent": 55,
      "defence": 65,
      "attack": 70,
      "positioning": 60,
      "average": 63
    },
    "profileYtVideoId": "38AhiUMRkag",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 162,
    "name": "Carlos Omabegho",
    "age": 28,
    "foot": "right",
    "height": 179,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/162.jpg",
    "macros": {
      "talent": 70,
      "defence": 65,
      "attack": 90,
      "positioning": 90,
      "average": 79
    },
    "profileYtVideoId": "ASb7-sU-K1I",
    "matchYtVideoId": "OrNox2KkiH8"
  },
  {
    "draftJersey": 164,
    "name": "Aitor Vives",
    "age": 25,
    "foot": "right",
    "height": 168,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/164.jpg",
    "macros": {
      "talent": 70,
      "defence": 80,
      "attack": 55,
      "positioning": 50,
      "average": 64
    },
    "profileYtVideoId": "h1XpwAo2oGA",
    "matchYtVideoId": "p6Z7j3aplTc"
  },
  {
    "draftJersey": 165,
    "name": "Joan Colomé",
    "age": 31,
    "foot": "left",
    "height": 173,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/165.jpg",
    "macros": {
      "talent": 90,
      "defence": 60,
      "attack": 100,
      "positioning": 100,
      "average": 88
    },
    "profileYtVideoId": "0PvHZYRS99s",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 166,
    "name": "Brandon Hernández",
    "age": 26,
    "foot": "right",
    "height": 178,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/166.jpg",
    "macros": {
      "talent": 85,
      "defence": 95,
      "attack": 95,
      "positioning": 90,
      "average": 91
    },
    "profileYtVideoId": "etT3KwouZOM",
    "matchYtVideoId": "c89PVJ6hZJk"
  },
  {
    "draftJersey": 168,
    "name": "Ivan Dionisio",
    "age": 34,
    "foot": "right",
    "height": 180,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/168.jpg",
    "macros": {
      "talent": 65,
      "defence": 60,
      "attack": 70,
      "positioning": 60,
      "average": 64
    },
    "profileYtVideoId": "wwySdpnw8xU",
    "matchYtVideoId": "n5zchLbrlZM"
  },
  {
    "draftJersey": 171,
    "name": "Cristian Domínguez",
    "age": 30,
    "foot": "right",
    "height": 179,
    "role": "MC",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/171.jpg",
    "macros": {
      "talent": 63,
      "defence": 60,
      "attack": 68,
      "positioning": 65,
      "average": 64
    },
    "profileYtVideoId": "IPLNPNE4re4",
    "matchYtVideoId": "t8mY0Qrb25A"
  },
  {
    "draftJersey": 172,
    "name": "Juanma González",
    "age": 30,
    "foot": "right",
    "height": 190,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/172.jpg",
    "macros": {
      "talent": 80,
      "defence": 85,
      "attack": 85,
      "positioning": 80,
      "average": 83
    },
    "profileYtVideoId": "Ax2ijI-PnoM",
    "matchYtVideoId": ""
  },
  {
    "draftJersey": "070",
    "name": "Iker Alcarazo",
    "age": 21,
    "foot": "right",
    "height": 191,
    "role": "DL",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/070.jpg",
    "macros": {
      "talent": 55,
      "defence": 65,
      "attack": 70,
      "positioning": 70,
      "average": 65
    },
    "profileYtVideoId": "Wx8YBeiE8Kk",
    "matchYtVideoId": "lduHiS77JoE"
  },
  {
    "draftJersey": "001",
    "name": "Albert Dalmau",
    "age": 31,
    "foot": "right",
    "height": 177,
    "role": "DF",
    "imageUrl": "https://cms-es.kingsleague.pro/old_drafts/draft0823/001.jpg",
    "macros": {
      "talent": 50,
      "defence": 70,
      "attack": 75,
      "positioning": 70,
      "average": 73
    },
    "profileYtVideoId": "",
    "matchYtVideoId": "VSjoFanU7aM"
  }
]
